import styled from 'styled-components';

const Icon = styled.img`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  max-height: 28px;
  max-width: 28px;
`;

export default Icon;
